import ApiClient from './ApiClient';

class TopicsAPI extends ApiClient {
  constructor() {
    super('topics', { accountScoped: true });
  }
}

export default new TopicsAPI();
